import { getStylesObjFromCss } from "../../../../../utils/common/styling";

export const styles = getStylesObjFromCss({
  styles: {
    postText: {
      whiteSpace: "pre-wrap",
      fontSize: "14px",
    },
    lockedPostImg: {
      width: "100%",
      marginTop: "8px",
      marginBottom: "8px",
    },
  },
  componentName: "LockedPost",
});
